
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/player/sdk/reference",
      function () {
        return require("private-next-pages/player/sdk/reference/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/player/sdk/reference"])
      });
    }
  